var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _vm.fileArr.length > 0 && _vm.listType === 'text' ? _c('div', {
    staticClass: "file-list"
  }, _vm._l(_vm.fileArr, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "file-item__name"
    }, [_c('div', {
      staticClass: "file-item__icon",
      domProps: {
        "innerHTML": _vm._s(_vm.renderIcon(item))
      }
    }), _c('span', {
      staticClass: "file-item__text"
    }, [_vm._v(_vm._s(item.name))])]), _c('div', {
      staticClass: "file-item__result"
    }, [!_vm.readonly ? _c('div', [item.progressFlag ? _c('div', [_c('el-progress', {
      attrs: {
        "percentage": item.progressPercent
      }
    })], 1) : _c('div', {
      staticClass: "file-item__result__text"
    }, [item.successFlag ? _c('el-link', {
      attrs: {
        "type": "success",
        "underline": false
      }
    }, [_vm._v(" 上传成功! ")]) : _c('el-link', {
      attrs: {
        "type": "danger",
        "underline": false
      }
    }, [_vm._v(" 上传失败! ")])], 1)]) : _c('div', [_vm._v("   ")])]), _c('div', {
      staticClass: "file-item__size file-item__text"
    }, [_vm._v(" " + _vm._s(_vm.formatFileSize(item.size)) + " ")]), _c('div', {
      staticClass: "file-item__links"
    }, [_c('el-link', {
      staticClass: "file-item__links--download",
      attrs: {
        "type": "primary",
        "href": item.url,
        "disabled": item.progressFlag
      }
    }, [_vm._v(" [下载] ")]), !_vm.readonly ? _c('el-link', {
      attrs: {
        "type": "danger",
        "disabled": item.progressFlag
      },
      on: {
        "click": function ($event) {
          return _vm.handleRemove(item);
        }
      }
    }, [_vm._v(" [删除] ")]) : _vm._e(), _vm.showPreview(item) ? _c('el-link', {
      attrs: {
        "type": "info",
        "disabled": item.progressFlag
      },
      on: {
        "click": function ($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" [预览] ")]) : _vm._e()], 1)]);
  }), 0) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };